import {
  Box,
  Flex,
  Text,
} from "@chakra-ui/react";
import TableTransferRequests from "./tableTransferRequests";
export default function TransferRequests() {
  return (
    <Box
      w={{ base: "100%" }}
      backgroundColor="var(--color-backgroundmain)"
      p={{ base: "24px 16px 16px" }}
    >
      <Flex alignItems={"center"} justifyContent={"space-between"}>
        <Flex alignItems={"center"} gap={{ base: "74px" }}>
          <Text fontSize={{ base: "20px" }} fontWeight={600}>
            Quản lý phiếu đăng ký chuyển giao dịch
          </Text>
        </Flex>
      </Flex>
      <Box mt={{ base: "23px" }}>
        <TableTransferRequests />
      </Box>
    </Box>
  );
}
